// import Cookies from 'js-cookie'
import api from '@/services/api'
import User from '@/models/User'

export default {
  namespaced: true,
  state: {
    user: {},
    isAuthenticated: false,
    token: {
      accessToken: null,
      expiresIn: null,
      tokenType: 'Bearer',
      uuid: null
    },
    timestamp: new Date().getTime()
  },

  getters: {
    avatarThumb(state) {
      return state.user.avatar_thumb_url + '?timestamp=' + state.timestamp
    },
    currentUserGroup(state) {
      return state.user.current_group
    }
  },

  mutations: {
    setUser(state, user) {
      if (user instanceof User) {
        state.user = user
      } else {
        state.user = new User(user)
      }
    },

    setToken(state, token) {
      if (token) {
        // Cookies.set('AUTH_TOKEN', token)
        localStorage.setItem('AUTH_TOKEN', JSON.stringify(token))
        state.token = token
        state.isAuthenticated = true
      }
    },

    clearToken(state) {
      // Cookies.remove('AUTH_TOKEN')
      localStorage.removeItem('AUTH_TOKEN')
      state.token = {
        accessToken: null,
        expiresIn: null,
        tokenType: 'Bearer',
        uuid: null
      }
      state.isAuthenticated = false
    },

    changeTimestamp(state) {
      state.timestamp = new Date().getTime()
    }
  },

  actions: {
    init({ commit, dispatch }) {
      // const token = Cookies.getJSON('AUTH_TOKEN')
      const token = localStorage.getItem('AUTH_TOKEN')
      commit('setToken', JSON.parse(token))
      dispatch('getAuthenticatedUser')
    },

    login({ commit, dispatch }, credentials) {
      return api.post('/auth/login', credentials).then(({ data }) => {
        commit('setToken', data.data)
        return dispatch('getAuthenticatedUser')
      })
    },

    getAuthenticatedUser({ commit }) {
      api
        .get('/auth/me')
        .then(res => {
          commit('setUser', res.data.data)
        })
        .catch(err => {
          if (err.response.status === 401) {
            commit('clearToken')
          }
        })
    },

    logout({ commit }) {
      api.post('/auth/logout').then(() => {
        commit('clearToken')
      })
    },

    joinGroup({ dispatch }, group) {
      return new Promise(resolve => {
        api.post(`groups/${group.id}/join`).then(async () => {
          await dispatch('getAuthenticatedUser')
          resolve()
        })
      })
    },

    leaveGroup({ dispatch }, group) {
      return new Promise(resolve => {
        api.post(`groups/${group.id}/leave`).then(async () => {
          await dispatch('getAuthenticatedUser')
          resolve()
        })
      })
    }
  }
}
